<template>
  <div class="map-wrap">
    <div id="map">
    </div>
  </div>
</template>

<script>
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';

// import { bindLayerCursor } from '@/utils'

// import { ZoomControl } from 'mapbox-gl-controls';
// import 'mapbox-gl-controls/lib/controls.css';
// mapboxgl.accessToken = 'pk.eyJ1IjoiZXhhbXBsZXMiLCJhIjoiY2p0MG01MXRqMW45cjQzb2R6b2ptc3J4MSJ9.zA2W0IkI0c6KaAhJfk9bWg1';
let map = null;
export default {
  name: 'index',
  data () {
    return {
      radioStyle: {
        display: 'block',
        height: '24px',
        lineHeight: '24px',
        mapControl: null,
        markerControl: null
      }
    };
  },
  components: {
  },
  methods: {
    changeLayer (e) {
      let value = e.target.value
      map.setLayoutProperty('tdt-vec-layer', 'visibility', value === 'a' ? 'visible' : 'none')
      map.setLayoutProperty('tdt-img-layer', 'visibility', value === 'b' ? 'visible' : 'none')
    }
  },
  mounted () {
    map = new mapboxgl.Map({
      container: 'map',
      pitchWithRotate: false,
      dragRotate: false,
      style: {
        version: 8,
        name: 'LWG',
        sources: {
          TDT_img: {
            type: 'raster',
            tiles: [
              './tiles/{z}/{x}/{y}.png'
            ],
            tileSize: 256,
            minzoom: 1,
            maxzoom: 18,
            scheme: 'tms',
            bounds: [111.58453, 29.437804, 111.689501, 29.521936],
            volatile: true
          },
          arc_img: {
            type: 'raster',
            tiles: [
              // 'http://wprd01.is.autonavi.com/appmaptile?lang=zh_cn&size=1&style=7&x={x}&y={y}&z={z}'
              'https://server.arcgisonline.com/arcgis/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}'
            ],
            tileSize: 256,
            minzoom: 1,
            maxzoom: 17,
            volatile: true
          }
        },
        center: [0, 0],
        zoom: 3,
        sprite: window.location.origin + window.location.pathname + 'assets/sprite/sprite',
        glyphs: './assets/font/{fontstack}/{range}.pbf',
        layers: [],
        draft: false
      },
      zoom: 12.97,
      minZoon: 9,
      maxZoom: 24,
      center: [111.63308739214995, 29.483488775031603],
      preserveDrawingBuffer: true,
      clickTolerance: 5
    });
    map.on('load', () => {
      window.map = map;
      this.$bus.$emit('mapLoad')
      map.addLayer({
        id: 'arc-img-layer',
        type: 'raster',
        source: 'arc_img'
      });
      map.addLayer({
        id: 'tdt-img-layer',
        type: 'raster',
        source: 'TDT_img'
      });
      map.on('click', (e) => {
        this.$bus.$emit('mapMouseClick', e);
        this.$emit('mapMouseClick', e);
      });
      // map.addSource('rangeSource', {
      //     type: 'geojson',
      //     data: './assets/range.geojson'
      // })
      // map.addLayer({
      //   id: 'rangeFill',
      //   type: 'fill',
      //   source: 'rangeSource',
      //   paint: {
      //     'fill-color': '#44cef6',
      //     'fill-opacity': 0.2
      //   }
      // })
      // map.addLayer({
      //   id: 'rangeLine',
      //   type: 'line',
      //   source: 'rangeSource',
      //   paint: {
      //     'line-color': '#44cef6',
      //     'line-width': 4
      //   },
      //   layout: {
      //     'line-cap': 'round',
      //     'line-join': 'round'
      //   }
      // })
    });
  }
};
</script>

<style scoped lang="less">
.map-wrap {
  width: 100%;
  height: 100%;
  #map {
    width: 100%;
    height: 100%;
    .layers-button {
      position: absolute;
      right: 50px;
      top: 10px;
      background-color: white;
      padding-left: 8px;
      border-radius: 4px;
       border: 1px solid #d9d9d9;
      z-index: 10000;
    }
  }
}
</style>
